<template>
    <transition name="fade" mode="out-in">
        <section v-if="hasProducts" class="product-tip-display">
			<hr v-if="noElementAbove" />
				<div class="bundle-info-wrap">
					<div class="bundle-image-wrap">
						<template v-for="(selectedProduct, index) in selectedProducts">
							<span v-if="index !== 0" class="glyphicon glyphicon-plus" :key="'bundle-plus-' + index" />
							<ximg
								:src="src(selectedProduct.id)"
								:ariaLabel="selectedProduct.name"
								:key="'bundle-product-' + index"
								role="img"
							/>
						</template>
					</div>
					<div class="bundle-price-wrap">
						<span class="text-highlight">{{ bundleText }}</span>
						<span :class="['price-value', {'_campaign': isBundle && isDiscounted}]">{{ totalPrice }}</span>
						<span v-if="totalRebate > 0 && (isBundle && isDiscounted)" class="small text-secondary">
							<span class="original-price">{{ noCampaignPrice }}</span>
							(Du sparar {{ priceSavings }}!)
						</span>
					</div>
					<text-button
						v-if="! buyButtonClicked"
						text="Lägg paket i varukorg"
						variant="secondary"
						leftIcon="plus"
						:disabled="onlyStorePickup"
						@click.prevent="updateButton"
					/>
					<text-button
						v-else-if="buyButtonClicked"
						text="Gå till varukorgen"
						variant="cart"
						rightIcon="chevron_right"
						@click.prevent="updateButton"
					/>
				</div>
				<div class="bundle-product-list">
					<product-tip-product :product="product" :disabled="true" :isBundle="true" />
					<product-tip-product
						v-for="offer in products"
						v-if="offer.id !== product.id"
						:key="offer.id"
						:product="offer"
						@update-checkbox="updateSelectedProducts"
						:isBundle="! isBundle || isDiscounted"
					/>
				</div>
			<hr />
        </section>
    </transition>
</template>

<script>
import alert from 'alert';
import bus from 'eventbus';
import store from 'datastore';
import { mapGetters } from 'vuex';
import { convertToCdnUrl, formatPrice } from 'utils';

export default {
	store,
	props: {
		product: {
			type: Object,
			required: true,
		},
		bundleOffers: {
			type: Object,
			required: true,
		},
		noElementAbove: {
			type: Boolean,
			default: false,
		},
	},
	data () {
		return {
			products: [],
			totalPrice: '',
			isBundle: false,
			totalRebate: 0,
			priceSavings: '',
			noCampaignPrice: '',
			selectedProducts: [],
			buyButtonClicked: false,
			mainProdAdded: false,
		};
	},
	mounted() {
		this.updateProducts();
		bus.$on('product-page.main-product-added', this.toggleMainProd);
		bus.$on('btn.update', () => {
			this.buyButtonClicked = false;
		});
	},
	beforeDestroy () {
		bus.$off('product-page.main-product-added');
		bus.$off('btn.update');
	},
	methods: {
		convertToCdnUrl,
		addToCart () {
			if (! this.bundleSelected) {
				alert('Kunde inte lägga paket i varukorgen. Paketet är tomt.');
				return;
			}
			const cartProducts = [];
			const productIdsInCart = [];

			this.cart.rows.forEach(product => {
				productIdsInCart.push(product.product.id);
			});

			// Checks if main product is already added via product page, if so it wont be added again
			if (! this.mainProdAdded) {
				cartProducts.push({ product: this.product, amount: 1 });
			}

			this.selectedProducts.forEach(product => {
				const copyProduct = Object.assign({}, product);
				if (product.id !== this.product.id && ! productIdsInCart.includes(product.id)) {
					cartProducts.push({ product: copyProduct, amount: 1 });
				}
			});

			if (this.isBundle && ! this.isDiscounted) {
				cartProducts.forEach((product, key) => {
					if (this.product.id !== product.product.id) {
						cartProducts[key].product.price = product.product.regularPrice;
					}
				});
			}

			if (this.products.length) {
				const extraData = {};
				extraData.isLoggedIn = this.isLoggedIn;
				extraData.source = this.$route.name;
				const trackingData = {
					event: 'addToCart',
					source: 'Product page bundle',
					coupon: true,
				};
				this.$store.dispatch('cart/addMany',{
					products: cartProducts,
					extraData: extraData,
					trackingData: trackingData,
				});
			}
		},
		src (productId) {
			return convertToCdnUrl('/images/product/' + productId + '?trim&h=80');
		},
		isSelected (product) {
			return this.selectedProducts.indexOf(product) !== -1;
		},
		updateProducts () {
			this.products = [];
			if (this.bundleOffers.products) {
				this.products = this.bundleOffers.products.filter((value, index, self) =>
					index === self.findIndex((t) => (
						t.id === value.id
					))
				)
				this.isBundle = this.bundleOffers.isBundle;
			}
		},
		calcTotalPrice () {
			let totalPrice = parseInt(this.product.price.price);
			this.products.forEach(offer => {
				if (this.isSelected(offer) && offer.id !== this.product.id) {
					totalPrice += parseInt(offer.price.price);
				}
			});
			this.totalPrice = formatPrice(totalPrice, 'SEK');
		},
		calcNoCampaignPrice () {
			let totalPrice = parseInt(this.product.price.price);
			this.products.forEach(offer => {
				if (this.isSelected(offer))
					totalPrice += parseInt(offer.regularPrice.price);
			});
			this.noCampaignPrice = formatPrice(totalPrice, 'SEK');
		},
		calcPriceSavings () {
			this.totalRebate = 0;
			this.products.forEach(offer => {
				if (this.isSelected(offer))
					this.totalRebate += parseInt(offer.regularPrice.price) - parseInt(offer.price.price);
			});

			this.priceSavings = formatPrice(this.totalRebate, 'SEK');
		},
		updateSelectedProducts (update) {
			const selectedProductIndex = this.selectedProducts.indexOf(update.product);

			if (update.checked && selectedProductIndex === -1) {
				this.selectedProducts.push(update.product);
			} else if (! update.checked) {
				this.selectedProducts.splice(selectedProductIndex, 1);
			}
		},
		calcNormalPrice () {
			this.totalRebate = 0;
			let totalPrice = parseInt(this.product.price.price);
			this.products.forEach(offer => {
				if (this.isSelected(offer)) {
					totalPrice += parseInt(offer.regularPrice.price);
				}
			});
			this.totalPrice = formatPrice(totalPrice, 'SEK');
		},
		updateButton () {
			if (this.$parent.$options._componentTag != 'product') {
				this.addToCart();
				return;
			}
			if (! this.buyButtonClicked) {
				this.buyButtonClicked = true;
				bus.$emit('product-page.add-to-cart', 'bundle');
				this.addToCart();
			} else {
				bus.$emit('cart:open');
				bus.$emit('product-page.remove-from-cart');
			}
		},
		toggleMainProd () {
			this.mainProdAdded = true;
		},
		inWarehouseStock(warehouses) {
			const CW = Object.values(warehouses);

			if (CW.find((stock) => stock > 0)) {
				return true;
			}

			return false;
		},
	},
	watch: {
		bundleOffers (data) {
			this.updateProducts();
		},
		products (value) {
			if (value) {
				this.selectedProducts = Array.from(value);
			}
		},
		selectedProducts () {
			if (this.isDiscounted) {
				this.calcTotalPrice();
				this.calcNoCampaignPrice();
				this.calcPriceSavings();
			} else {
				this.calcNormalPrice();
			}
		},
	},
	computed: {
		onlyStorePickup () {
			const stock = this.inWarehouseStock(this.product.stock.warehouseStock);

			return this.product.discontinued && stock === false;
		},
		cart () {
			return this.$store.state.cart;
		},
		isDiscounted () {
			if (this.bundleOffers.isBundle) {
				return this.selectedProducts.length === this.products.length;
			}
			return true;
		},
		bundleSelected () {
			return this.selectedProducts.length;
		},
		hasProducts () {
			return this.products && this.products.length;
		},
		bundleText () {
			return this.isBundle && this.isDiscounted ? 'Paketpris' : 'Köp produkten med tillbehör';
		},
		...mapGetters({
			isLoggedIn: 'user/isLoggedIn',
		}),
	},
};
</script>
